import React from "react";
import { useLocation, useHistory } from "react-router-dom";

// custom pages
import { styles } from "./style"

// material-ui
import Grid from "@material-ui/core/Grid";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
// language purpose i18n package 
import { useTranslation } from 'react-i18next';
import Button from "@material-ui/core/Button";

function UploadSuccess() {
  const location = useLocation();
  const history = useHistory();
  const classes = styles();
  const{t,i18n}= useTranslation()
  let data = {};
  if (location.state?.type) {
    data = location.state?.type;
  } else {
    history.goBack();
  }

  return (
    <div>
      <Grid item xs={12} className={classes.contentGrid}>
        <div className={classes.content1}>
          <CheckCircleOutlineIcon className={classes.checkIcon} />
          &nbsp; {t('Congratulations!')}
        </div>
        <div className={classes.content2}>
          <pre>{data}</pre>
        </div>
        <Button
          className={classes.backBtn}
          onClick={() => history.goBack()}
        >{t('Back')}</Button>
      </Grid>
    </div>
  );
}

export default UploadSuccess;
